var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16.238,
    viewBox: "0 0 17 16.238",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-3",
    transform: "translate(-2.15 -2.029)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2710",
    "data-name": "Group 2710",
    transform: "translate(2.15 2.029)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2048",
    "data-name": "Path 2048",
    d: "M19.65,20.53H11.84a.69.69,0,1,1,0-1.38h7.81a.69.69,0,0,1,0,1.38Z",
    transform: "translate(-3.34 -4.293)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2049",
    "data-name": "Path 2049",
    d: "M15.857,2.029a2.531,2.531,0,0,1,1.79,4.321L6.8,17.2a.69.69,0,0,1-.321.182l-3.471.868a.69.69,0,0,1-.837-.837l.868-3.471a.69.69,0,0,1,.182-.321L14.067,2.77A2.514,2.514,0,0,1,15.857,2.029Zm-9.9,14.056L16.67,5.373a1.151,1.151,0,0,0-1.627-1.627L4.331,14.458l-.542,2.17Z",
    transform: "translate(-2.15 -2.029)",
    fill: "#707070"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.c10460102b550b6f5172cab3ff50ff90.svg";
export { ForwardRef as ReactComponent };